export default "__VITE_ASSET__BmX2zX7c__"